// extracted by mini-css-extract-plugin
export default {"flatlist":"c47e58b017613b0ab83f","container":"d6cea75543d4b66bedb3","popuplist":"ffd6bbae489cd728cb4b"};